<template>
  <div class="progress-review__modal">
    <div class="progress-review__modal-container">
      <div class="progress-review__close-btn-container">
        <XIcon
          class="progress-review__close-btn-icon"
          color="#fff"
          @click="closeModal"
        />
      </div>
      <h3 class="progress-review__title">You're almost done!</h3>
      <p class="progress-review__message">
        Before finishing this course, would you tell us what you think about the
        content and the instructor?
      </p>
      <div class="progress-review__actions">
        <button
          class="progress-review__rate-btn btn btn--primary btn--small"
          @click="handleRateNow"
        >
          Rate now
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { XIcon } from 'vue-feather-icons'
import { mapActions } from 'vuex'

export default {
  name: 'ProgressReviewModal',
  components: {
    XIcon,
  },
  props: {
    progress: {
      type: Number,
      required: true,
    },
  },
  methods: {
    ...mapActions('courses', [
      'toggleUserStatusInfo',
      'sendCourseUserPreferences',
    ]),
    closeModal() {
      let payload = null
      if (parseInt(this.progress) >= 50 && parseInt(this.progress) < 90) {
        payload = {
          prompt_review_50_perc_completion: true,
        }
      } else if (parseInt(this.progress) >= 90) {
        payload = {
          prompt_review_90_perc_completion: true,
        }
      }
      this.toggleUserStatusInfo(payload)
      this.sendCourseUserPreferences(payload)
    },
    handleRateNow() {
      this.$emit('rate-course')
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.progress-review {
  &__modal {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 300px;
    background: var(--darker-gray);
    box-shadow: 0px 0px 99px #000000ba;
    border-radius: 10px;
    z-index: 100;
    transition-delay: 2s;
    overflow: hidden;

    &-container {
      padding: 20px;
      background: var(--glass-mid-gray), #1e1e1e;
    }
  }
  &__title {
    margin: 0;

    color: var(--white);
    font-feature-settings: 'clig' off, 'liga' off;

    font-size: 1.125rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.5rem; /* 133.333% */
  }
  &__message {
    margin: 5px 0 20px;

    color: var(--light-blue-gray);
    font-feature-settings: 'clig' off, 'liga' off;

    font-size: 0.875rem;
    font-style: normal;
    font-weight: 450;
    line-height: 1.25rem; /* 142.857% */
  }
  &__close-btn {
    &-container {
      display: flex;
      justify-content: flex-end;
    }
    &-icon {
      color: var(--light-blue-gray);
      cursor: pointer;
    }
  }
  &__actions {
    display: flex;
    justify-content: flex-end;
  }
  &__link {
    color: var(--black);
    font-weight: bold;
    font-family: var(--font-bold);
  }
  &__review-btn {
    border-color: var(--orange) !important;
    color: var(--black);
  }
}
</style>
